export enum FeatureFlagEnum {
  qaMode = 'qa-mode',
  shortestLeaveInterval = 'shortest-leave-interval',
  lessThanOneHourLeave = 'less-than-one-hour-leave',
  accruals = 'accruals',
  toil = 'toil',
  labels = 'labels',
  scheduledReports = 'scheduled-reports',
  hours = 'hours',
  calculationStartYear = 'calculation-start-year',
  companyLogs = 'company-logs',
  importUsers = 'import-users',
  aiBotHelper = 'ai-bot-helper',
  noLimitTeams = 'no-limit-teams',
  noLimitLocation = 'no-limit-location',
  multiLevelApproval = 'multi-level-approval',
  accrualCapInputField = 'accrual-cap-input-field',
  // IMPORTANT
  // FOR ALL NEW ADDONS, AND A NEW ENUM. WE ALOSE NEED TO ADD THE ADDONS IN CONSTATS IN `backend/src/automations/common/automations-feature-fags.ts`
  // Start Automation:
  automation = 'automation', // This is the feature flag for all automations
  addon = 'addon', // This is the feature flag for all addons
  blackOutPeriod = 'blackout-period',
  entitlementByRole = 'entitlement-by-role',
  seniorityEntitlement = 'seniority-entitlement',
  probationPeriod = 'probation-period',
  maximumUsersAway = 'maximum-users-away',
  leaveDurationLimit = 'leave-duration-limit',
  leaveRequestNoticePeriod = 'leave-request-notice-period',
  // End Automation
  // Start Addons
  visibility = 'visibility',
  openApi = 'open-api',
  // End Addons
  syncSharedCalendars = 'sync-shared-calendars',
  substituteApprovers = 'substitute-approvers',
  googleAdminPermissions = 'google-admin-permissions',
  workday = 'workday',
  reports = 'reports',
  freemiumPlan = 'freemium-plan',
  // NED IMPORTANT
  notifyToWatchers = 'notify-to-watchers',
  // Managed through Posthog
  aiAssistedOnboarding = 'ai-assisted-onboarding',
  slackAgentV2 = 'slack-agent-v2',
  teamsAgentV2 = 'teams-agent-v2',
  spanishLanguage = 'app-spanish-language',
  portugueseLanguage = 'app-portuguese-language',
  germanLanguage = 'app-german-language',
  italianLanguage = 'app-italian-language',
  polishLanguage = 'app-polish-language',
  turkishLanguage = 'app-turkish-language',
  swedishLanguage = 'app-swedish-language',
  negativeBroughtForward = 'app-negative-brought-forward',
  emailUserImport = 'app-email-import-users',
  enableMinutePickerLeave = 'enable-minute-picker-leave',
  notificationServiceV2 = 'notification-service-v2',
  userInsightsEnergyScore = 'user-insights-energy-score',
  onboardingV2 = 'onboarding-v2',
  disableSyncUsers = 'disable-sync-users',
  rechargeType = 'user-recharge-type',
  onboardingCallCtaAb = 'onboarding-call-cta-ab',
  rolesAndPermissions = 'roles-and-permissions',
  roleAdaptiveDashboard = 'role-adaptive-dashboard',
  teamEnergy = 'team-energy',
}
// READ TEXT ON TOP OF THE FILE
